// Alt text for logo images that have no imageAltText in the CMS: the name
// from the file ("Next-Insurance-logo-white.png" -> "Next Insurance logo"),
// or the link's host ("https://www.amdocs.com/" -> "amdocs.com logo").
// An image that is the only content of a link needs alt text, or the link
// has no accessible name (Lighthouse link-name / image-alt).
const NOISE =
  /^(logo|white|light|dark|black|color|colour|big|small|icon|\d+)$/i;

export const logoAlt = (imageAltText, image, link) => {
  if (imageAltText) return imageAltText;
  const file =
    image && (image.name || (image.publicURL || "").split("/").pop());
  const words = (file || "")
    .replace(/\.[a-z0-9]+$/i, "")
    .split(/[-_\s]+/)
    .filter((word) => word && !NOISE.test(word));
  if (words.length) return `${words.join(" ")} logo`;
  if (link) {
    try {
      return `${new URL(link).hostname.replace(/^www\./, "")} logo`;
    } catch (e) {
      return "";
    }
  }
  return "";
};

export default logoAlt;
